import apiPasarela from "../apiPasarela";

const getPromociones = async (params) => {
  const endpoint = "/administracion/promociones";
  const { data } = await apiPasarela.get(endpoint, { params });
  return data;
};

const postCuentaPromociones = async (body) => {
  const endpoint = "/administracion/cuenta-promociones";
  const { data } = await apiPasarela.post(endpoint, body);
  return data;
};

const createPromocion = async (payload) => {
  const endpoint = "/administracion/promocion";
  const { data } = await apiPasarela.post(endpoint, payload);
  return data;
};

const updatePromocion = async (payload) => {
  const endpoint = "/administracion/promocion";
  const { data } = await apiPasarela.put(endpoint, payload);
  return data;
};

const getBines = async () => {
  const endpoint = "/administracion/bin-tarjetas";
  const { data } = await apiPasarela.get(endpoint);
  return data;
};

const createBin = async (payload) => {
  const endpoint = "/administracion/bin-tarjeta";
  const { data } = await apiPasarela.post(endpoint, payload);
  return data;
};

const createPlan = async (payload) => {
  const endpoint = "/administracion/mediopagoinstallments";
  const { data } = await apiPasarela.post(endpoint, payload);
  return data;
};

const getChannelsAndMedios = async (params) => {
  const endpoint = "/administracion/channels-mediopago";
  const { data } = await apiPasarela.get(endpoint, { params });
  return data;
};

const getSites = async (params) => {
  const endpoint = "/administracion/sites";
  const { data } = await apiPasarela.get(endpoint, { params });
  return data;
};

const actDesactPromocion = async (promocionId, activo) => {
  const endpoint = `/administracion/cuenta-promociones/${promocionId}/activo`;
  const { data } = await apiPasarela.put(endpoint, { activo });
  return data;
};

const deletePromocion = async (id) => {
  const endpoint = `/administracion/promocion/${id}`;
  const { data } = await apiPasarela.delete(endpoint);
  return data;
};

const deleteCuentaPromocion = async (cuentaPromocionId) => {
  const endpoint = `/administracion/cuenta-promociones/${cuentaPromocionId}`;
  const { data } = await apiPasarela.delete(endpoint);
  return data;
};

export default {
  getPromociones,
  postCuentaPromociones,
  createPromocion,
  updatePromocion,
  getBines,
  createBin,
  createPlan,
  getChannelsAndMedios,
  getSites,
  actDesactPromocion,
  deletePromocion,
  deleteCuentaPromocion,
};
